import { httpClient } from '../httpClient';
import {
  IMusicGeneration,
  CreateMusicGenerationRequest,
  PaginatedResponse,
  MusicGenerationQuery,
  PaginationQuery,
  GenerateLyricsRequest,
  GenerateLyricsResponse,
  IMusicEditing,
} from '@packages/global';

/**
 * 用户音乐生成 API 模块
 * 处理用户音乐生成管理操作
 */
export class MusicApi {
  /**
   * 获取用户音乐生成分页列表（POST，强类型）
   */
  async musicGenerationPageList(queryData: PaginationQuery<MusicGenerationQuery>): Promise<PaginatedResponse<IMusicGeneration>> {
    return httpClient.post<PaginatedResponse<IMusicGeneration>>('/user/music-generations/page', queryData);
  }

  /**
   * 创建音乐生成任务
   */
  async createMusicGeneration(data: CreateMusicGenerationRequest): Promise<IMusicGeneration> {
    return httpClient.post<IMusicGeneration>('/user/music-generations', data);
  }

  /**
   * 获取音乐生成任务详情
   */
  async getMusicGeneration(id: string): Promise<IMusicGeneration> {
    return httpClient.get<IMusicGeneration>(`/user/music-generations/${id}`);
  }

  /**
   * AI 生成 Caption + 歌词
   */
  async generateLyrics(data: GenerateLyricsRequest): Promise<GenerateLyricsResponse> {
    return httpClient.post('/user/music-generations/generate-lyrics', data);
  }

  /**
   * 删除音乐生成任务
   */
  async deleteMusicGeneration(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/music-generations/${id}`);
  }

  /**
   * 更新音乐生成标题
   */
  async updateMusicGenerationTitle(id: string, title: string): Promise<void> {
    return httpClient.patch<void>(`/user/music-generations/${id}/title`, { title });
  }

  /**
   * 更新音乐编辑标题
   */
  async updateMusicEditingTitle(id: string, title: string): Promise<void> {
    return httpClient.patch<void>(`/user/music-editings/${id}/title`, { title });
  }

  /**
   * 获取音乐编辑分页列表（供卡片页面使用）
   */
  async musicEditingPageList(queryData: PaginationQuery<any>): Promise<PaginatedResponse<IMusicEditing>> {
    return httpClient.post<PaginatedResponse<IMusicEditing>>('/user/music-editings/page', queryData);
  }
}

// 导出单例实例
export const musicApi = new MusicApi();
